export default "__VITE_ASSET__DLOXuDMv__"